var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-right","appear":""}},[(_vm.showing)?_c('div',{staticClass:"nan-banner bg-white px-3 py-2"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }